/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 
 */

/**
 * Flickity carousel: auto-play when the carousel enters the viewport, pause when it leaves.
 * Applies to all .Carousel elements. Uses each carousel's existing autoPlay interval if set,
 * otherwise falls back to DEFAULT_INTERVAL.
 */
(function () {
  var DEFAULT_INTERVAL = 3000;

  function initAutoPlayOnVisible(carousel) {
    if (!window.Flickity) return;
    var flkty = Flickity.data(carousel);
    if (!flkty) return;

    var interval = flkty.options.autoPlay || DEFAULT_INTERVAL;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (!flkty.options.autoPlay) {
            flkty.options.autoPlay = interval;
          }
          flkty.playPlayer();
        } else {
          flkty.stopPlayer();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(carousel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.Carousel[data-flickity-config]').forEach(initAutoPlayOnVisible);
  });
})();

/**
 * Flickity wrapAround boundary fix for StylingRecommend slider.
 *
 * Root cause: _shiftCells uses strict `e > 0`. When cells are exactly
 * innerWidth/N wide, at the last visible cell position i=0 exactly, so
 * afterShiftCells lose wrapShift(1) and jump to wrapShift(0) — the leftmost
 * cell's style.left suddenly changes from right-edge back to left-edge.
 *
 * Fix: patch shiftWrapCells to use `i >= 0` for afterShiftCells only.
 * beforeShiftCells must stay strict `> 0` (at x=0, e=0 — non-strict would
 * wrongly apply wrapShift(-1) to cell4 on the initial position).
 */
(function () {
  function patchFlickityWrapAround() {
    if (!window.Flickity || !Flickity.prototype.shiftWrapCells) return;
    Flickity.prototype.shiftWrapCells = function (t) {
      if (!this.beforeShiftCells || !this.afterShiftCells) return;
      var e = this.cursorPosition + t;
      for (var n = 0; n < this.beforeShiftCells.length; n++) {
        var bc = this.beforeShiftCells[n];
        bc.wrapShift(e > 0 ? -1 : 0);
        e -= bc.size.outerWidth;
      }
      // Use >= 0 only when cells outnumber the visible slots (slideableWidth > innerWidth).
      // When all cells fit exactly (slideableWidth == innerWidth), i=0 on the last cell
      // means that cell is the selected/visible cell — shifting it would push it off-screen.
      var useGte = this.slideableWidth > this.size.innerWidth;
      var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
      for (var m = 0; m < this.afterShiftCells.length; m++) {
        var ac = this.afterShiftCells[m];
        ac.wrapShift((useGte ? i >= 0 : i > 0) ? 1 : 0);
        i -= ac.size.outerWidth;
      }
    };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchFlickityWrapAround);
  } else {
    patchFlickityWrapAround();
  }
})();

/**
 * StylingRecommend slider: duplicate cells when visible originals are 4 or fewer.
 * This stabilizes wrapAround layouts where the left edge can disappear.
 */
(function () {
  function duplicateStylingRecommendCells(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sliders = scope.querySelectorAll('.section-StylingRecommend .StylingRecommend__Slider');

    sliders.forEach(function (slider) {
      if (slider.dataset.wrapCloneApplied === 'true') return;

      var hasExistingClones = slider.querySelector('.StylingRecommend__SliderCell.is-clone');
      if (hasExistingClones) {
        slider.dataset.wrapCloneApplied = 'true';
        return;
      }

      var originalCells = Array.prototype.slice.call(
        slider.querySelectorAll(':scope > .StylingRecommend__SliderCell')
      );

      if (originalCells.length === 0 || originalCells.length > 4) {
        slider.dataset.wrapCloneApplied = 'true';
        return;
      }

      originalCells.forEach(function (cell) {
        var clone = cell.cloneNode(true);
        clone.classList.add('is-clone', 'is-clone-runtime');
        clone.removeAttribute('id');
        clone.removeAttribute('data-block-id');
        clone.setAttribute('aria-hidden', 'true');

        clone.querySelectorAll('[id]').forEach(function (el) {
          el.removeAttribute('id');
        });

        slider.appendChild(clone);
      });

      slider.dataset.wrapCloneApplied = 'true';

      if (window.Flickity) {
        var flkty = Flickity.data(slider);
        if (flkty) {
          flkty.reloadCells();
          flkty.reposition();
          flkty.resize();
        }
      }
    });
  }

  function runDuplicatePass(root) {
    // Wait one frame so section HTML and Flickity init have both had a chance to run.
    requestAnimationFrame(function () {
      duplicateStylingRecommendCells(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runDuplicatePass(document);
    });
  } else {
    runDuplicatePass(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    runDuplicatePass(event.target);
  });
})();

/**
 * Flickity carousel: disable "next" button immediately when the last cell is visible.
 * Flickity's built-in logic disables the button only when selectedIndex reaches the
 * last slide index, which — with contain:true — requires several extra clicks after the
 * visual end. We override this by checking the actual scroll position on every event.
 */
(function () {
  function fixCarouselNextButton(carousel) {
    if (!window.Flickity) return;
    var flkty = Flickity.data(carousel);
    if (!flkty || !flkty.options.prevNextButtons || flkty.options.wrapAround) return;

    function disableNextIfAtEnd() {
      if (!flkty.nextButton || !flkty.slideableWidth) return;
      var maxScroll = flkty.slideableWidth - carousel.offsetWidth;
      if (maxScroll <= 0) return;
      if (-flkty.x >= maxScroll - 1) {
        flkty.nextButton.disable();
      }
    }

    flkty.on('scroll', disableNextIfAtEnd);
    flkty.on('select', disableNextIfAtEnd);
    flkty.on('settle', disableNextIfAtEnd);
    flkty.on('resize', disableNextIfAtEnd);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.Carousel[data-flickity-config]').forEach(fixCarouselNextButton);
  });
})();


document.addEventListener('product:added', function(event) {
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
    // var finalPrice =  event.detail.price;
    // console.log(finalPrice);
});

document.addEventListener('DOMContentLoaded', function () {

    function initialize() {
        // スライダーとIntersectionObserverの処理
        setTimeout(() => {
            document.querySelectorAll('.product-image-wrapper').forEach(wrapper => {
                const slider = wrapper.querySelector('.product-image-slider');
                const images = slider.querySelectorAll('.product-image');
                const totalImages = images.length;

                let isDragging = false;
                let startX = 0;
                let currentTranslate = 0;
                let prevTranslate = 0;
                let currentIndex = 0;

                function enableDrag() {
                    if (window.innerWidth < 768) { // ウィンドウサイズが768px未満の場合はドラッグを許可
                        // ドラッグ開始
                        wrapper.addEventListener('mousedown', startDrag);
                        wrapper.addEventListener('touchstart', startDrag);

                        // ドラッグ中
                        wrapper.addEventListener('mousemove', drag);
                        wrapper.addEventListener('touchmove', drag);

                        // ドラッグ終了
                        wrapper.addEventListener('mouseup', endDrag);
                        wrapper.addEventListener('mouseleave', endDrag);
                        wrapper.addEventListener('touchend', endDrag);
                    } else {
                        // 768px以上の場合はドラッグを禁止
                        wrapper.removeEventListener('mousedown', startDrag);
                        wrapper.removeEventListener('touchstart', startDrag);
                        wrapper.removeEventListener('mousemove', drag);
                        wrapper.removeEventListener('touchmove', drag);
                        wrapper.removeEventListener('mouseup', endDrag);
                        wrapper.removeEventListener('mouseleave', endDrag);
                        wrapper.removeEventListener('touchend', endDrag);
                    }
                }

                // 初期化時にウィンドウサイズに応じたドラッグ設定
                enableDrag();

                // ウィンドウサイズが変更された場合にドラッグの許可・禁止を再設定
                window.addEventListener('resize', enableDrag);

                function startDrag(e) {
                    isDragging = true;
                    startX = getPositionX(e);
                    slider.style.cursor = 'grabbing';

                    // アニメーションを一時停止
                    slider.style.transition = 'none';
                }

                function drag(e) {
                    if (!isDragging) return;

                    const currentX = getPositionX(e);
                    const diff = currentX - startX;

                    currentTranslate = prevTranslate + diff;
                    setSliderPosition();
                }

                function endDrag() {
                    if (!isDragging) return;
                    isDragging = false;
                    slider.style.cursor = 'grab';

                    // スライド幅を計算
                    const slideWidth = wrapper.getBoundingClientRect().width;
                    const moveThreshold = slideWidth / 4;

                    // 次または前の画像に移動
                    if (currentTranslate - prevTranslate < -moveThreshold) {
                        currentIndex = Math.min(currentIndex + 1, totalImages - 1); // 次の画像
                    } else if (currentTranslate - prevTranslate > moveThreshold) {
                        currentIndex = Math.max(currentIndex - 1, 0); // 前の画像
                    }

                    // スライド位置を設定
                    setPositionByIndex();
                }

                function setPositionByIndex() {
                    currentTranslate = -currentIndex * wrapper.getBoundingClientRect().width;
                    prevTranslate = currentTranslate;

                    slider.style.transition = 'transform 0.3s ease';
                    setSliderPosition();
                }

                function setSliderPosition() {
                    slider.style.transform = `translateX(${currentTranslate}px)`;
                }

                function getPositionX(e) {
                    return e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
                }

                // 初期スライダー位置設定
                setPositionByIndex();
            });

        }, 4000); // 4秒遅延

       
    }

    // 初回読み込み時に処理を実行
    initialize();

    // // クエリパラメータ変更の監視
    // let previousSearch = location.search;

    // setInterval(function () {
    //     if (location.search !== previousSearch) {
    //         previousSearch = location.search;
    //         initialize(); // パラメータが変更されるたびに処理を実行
    //     }
    // }, 100); // 100msごとにチェック
    // 監視対象を取得
    const items = document.querySelectorAll('.ProductList--grid');

    // 要素が可視範囲に入っているかチェックする関数
    function checkVisibility() {
        items.forEach(item => {
            const rect = item.getBoundingClientRect(); // 要素の位置を取得
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0; // 可視範囲の判定

            if (isVisible) {
                item.classList.add('visible'); // 可視範囲に入ったらクラスを追加
            } else {
                item.classList.remove('visible'); // 可視範囲外になったらクラスを削除
            }
        });
    }

    // 初期チェック（ページ読み込み時）
    checkVisibility();

    // スクロールイベントを監視
    window.addEventListener('scroll', checkVisibility);

    setTimeout(() => {
    // すべてのサイズエリアを取得
    const allSizesElements = document.querySelectorAll('.ProductItem__Sizes');

    // サイズボタンをクリックしたとき
    const sizeButtons = document.querySelectorAll('.btn-size');
    sizeButtons.forEach(button => {
        button.addEventListener('click', event => {
            
            // ボタンから product.id を取得
            const productId = button.getAttribute('data-product-id');

            // 対応するサイズエリア（PCとスマホ両方）を取得
            const sizesElements = document.querySelectorAll(`.ProductItem__Sizes-${productId}`);

            // 他のサイズエリアを閉じる
            allSizesElements.forEach(el => {
                if (![...sizesElements].includes(el)) {
                    el.style.display = 'none';
                    el.classList.remove('visible');
                }
            });

            // 対応するサイズエリア（PCとスマホ両方）を表示
            sizesElements.forEach(sizesElement => {
                sizesElement.style.display = 'block';
                sizesElement.classList.add('visible');
            });

            // クリックイベントが他に伝播しないようにする
            event.stopPropagation();
        });
    });

    // 閉じるボタンをクリックしたとき
    const closeButtons = document.querySelectorAll('.ProductItem__Sizes-close');
    closeButtons.forEach(button => {
        button.addEventListener('click', event => {
            const sizesElement = button.closest('.ProductItem__Sizes');
            if (sizesElement) {
                sizesElement.style.display = 'none';
                sizesElement.classList.remove('visible');
            }

            // クリックイベントが他に伝播しないようにする
            event.stopPropagation();
        });
    });

    // ドキュメント全体でクリックイベントを監視
    document.addEventListener('click', () => {
        // すべてのサイズエリアを非表示にする
        allSizesElements.forEach(el => {
            el.style.display = 'none';
            el.classList.remove('visible');
        });
    });
    }, 2000);

    // hoshiba-commentの移動処理
    setTimeout(() => {
        const hoshibaCommentContainer = document.querySelector('.Rte #hoshiba-comment-container');
        const hoshibaComment = document.querySelector('.ProductMeta__Description #hoshiba-comment');
        console.log('hoshibaComment',hoshibaComment)
        console.log('hoshibaCommentContainer',hoshibaCommentContainer)
        if (hoshibaCommentContainer && hoshibaComment) {
            console.log('Moving hoshiba-comment to container');
            console.log('Before move - comment innerHTML:', hoshibaComment.innerHTML);
            hoshibaCommentContainer.appendChild(hoshibaComment);
            console.log('After move - container innerHTML:', hoshibaCommentContainer.innerHTML);
            console.log('Comment is now inside container:', hoshibaCommentContainer.contains(hoshibaComment));
        } else {
            console.log('Container or comment not found', {
                container: !!hoshibaCommentContainer,
                comment: !!hoshibaComment
            });
        }
    }, 100);
});

